// public api, cached on nextjs level
export async function getBuildVersion() {
    const resp = await fetch('/api/version', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const { version } = await resp.json();
    return version;
}
//# sourceMappingURL=getBuildVersion.js.map